import React, { Component } from "react";
import "./Tab.scss";

export default class Tab extends Component {
  render() {
    return (
      <li>
        <a
          onClick={this.props.onClick}
          className={
            "align-items-center d-flex h-100 nav-link mb-2" +
            (this.props.active ? " active" : "")
          }
          data-toggle="tab"
          href={"#" + this.props.idKey}
        >
          {this.props.children}
        </a>
      </li>
    );
  }
}
